module.exports = __webpack_public_path__ + "assets/img/panel.f905b2dc.svg";